import axios from "axios";
import { useRef } from "react";
import { config } from "../utils/Constants";
import TS from "../utils/TimeStampGenerator";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../components/ErrorHandler";
import { useToast } from "@chakra-ui/react";
import useExchangePortalAxios from "../utils/axios";
import jwtDecode from "jwt-decode";

const useGenerateToken = () => {
  const { ErrorHandler } = useErrorHandler();


  const URL = config.url;

  const navigate = useNavigate();

  const ExchangePortalClient = useExchangePortalAxios();


  const toast = useToast();
  const toastRef = useRef(null);

  const generateToken = async (sessionID, timerStatus, data) => {
    return await axios
      .post(
        URL + "/v1/Auth/GeneratePortalToken",
        { SessionID: sessionID},
        // { SessionID: sessionID, TS: TS() },
        {
          headers: {
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        var obj = res.data.Payload;
        for (var key in obj) {
          if (res.data.Payload.hasOwnProperty(key))
            sessionStorage.setItem(key, obj[key]);
          if (key === "Token") {
            const decodedToken = jwtDecode(obj[key]);
          }
        }
        // sessionStorage.setItem("EntityRole", "VIEWER");
        // toastRef.current = toast({
        //   position: "top",
        //   title: "Success",
        //   description: `Welcome, ${sessionStorage.getItem("UserName")}`,
        //   status: "success",
        //   duration: "5000",
        //   isClosable: "false",
        // });
        navigate("/Overview");
      })
      .catch((err) => {
        clearInterval(timerStatus);
        ErrorHandler(err);
        throw err;
      });
  };

  const generateRefreshToken = async (sessionID, refreshToken) => {
    return await ExchangePortalClient.post("/v1/Auth/RefreshPortalToken", {
      RefreshToken: refreshToken,
      SessionID: sessionID,
      TS: TS(),
    })
      .then((res) => {
        const token = res.data.Payload.Token;
        sessionStorage.setItem("Token", token);
        sessionStorage.setItem("EntityRole", res.data.Payload.Role);
        sessionStorage.setItem("EntityType", res.data.Payload.EntityType);
        sessionStorage.setItem("EntityID", res.data.Payload.EntityID);

        return res;
      })
      .catch((error) => {
        sessionStorage.clear();
        toastRef.current = toast({
          position: "top",
          title: "Error",
          description: `Your session has expired. Please login again.`,
          status: "error",
          duration: "5000",
          isClosable: "false",
        });
        navigate("/", { replace: true });
        // ErrorHandler(error);
        throw error;
      });
  };

  return {
    generateToken,
    generateRefreshToken,
  };
};

export default useGenerateToken;
